import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrganizationObject } from '@it2go/types';
import { selectRouteParam } from '../../../../../store/global/router.selector';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { OrganizationService } from '../../../../../services/organization.service';
import { OrganizationCenterPersonGqlService } from '../../../../../services/organization-center-person.gql-service';
import { UserService } from '../../../../../services/user.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { PersonTypeEnum } from '@libs/types/src/common/enum/person-type.enum';
import { OrganizationCenterPersonObject } from '@libs/types/src/organization/object-type/organization-center-person.object';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';

interface State {
    organization: OrganizationObject | null,
}

const defaultState: State = {
    organization: null,
};

@Injectable()
export class CenterDetailPageStore extends ComponentStoreFactory<State> {

    private readonly centerPersonApi = inject(OrganizationCenterPersonGqlService);
    public readonly organization = toSignal(this.data.organization$);

    center$ = this.select(
        this.globalStore!.select(selectRouteParam('centerId')),
        this.data.organization$,
        (centerId, organization) => organization?.centers?.find((it) => it.id.toString() == centerId),
    );

    constructor() {
        super(defaultState, inject(Store), inject(OrganizationService), inject(UserService));
    }

    public async getManagerIds(centerId: number): Promise<string[]> {
        const managers = await this.centerPersonApi.getOrganizationCenterPersons(
            FilterBuilder.singlePage({ centerId, type: PersonTypeEnum.MANAGER }),
            'userId',
        );

        return managers?.items.map((manager: OrganizationCenterPersonObject) => manager.userId) ?? [];
    }

    public async replaceManagers(centerId: number, userIds: string[]): Promise<void> {
        await this.centerPersonApi.replaceOrganizationCenterManagers({ centerId, userIds });
    }

}
